// A club's session types (Trampoline, DMT, Tumbling...). Sessions from the
// API carry sessionType { id, name, colour, needsApproval }; anything older
// only has the fixed type ('TRAMPOLINE' or 'DMT'), so these read either.

// The colours a type can have, by key. The backend has the same list
// (backend/services/sessionTypes.js).
export const SESSION_TYPE_COLOURS = {
  blue: { hex: '#1565c0', label: 'Blue' },
  green: { hex: '#2e7d32', label: 'Green' },
  purple: { hex: '#6a1b9a', label: 'Purple' },
  orange: { hex: '#e65100', label: 'Orange' },
  red: { hex: '#c62828', label: 'Red' },
  teal: { hex: '#00838f', label: 'Teal' },
  pink: { hex: '#ad1457', label: 'Pink' },
  grey: { hex: '#546e7a', label: 'Grey' },
};

// The name for an old fixed type, or a type name as it is
export const legacyName = (t) => (t === 'DMT' ? 'DMT' : t === 'TRAMPOLINE' ? 'Trampoline' : t);

// The session type of a session, template, register row or waitlist entry
export function typeOf(x) {
  if (!x) return null;
  if (x.sessionType) return x.sessionType;
  const legacy = x.type || x.apparatus;
  if (!legacy) return null;
  const dmt = legacy === 'DMT';
  return { id: null, name: legacyName(legacy), colour: dmt ? 'green' : 'blue', needsApproval: dmt };
}

export const typeName = (x) => typeOf(x)?.name ?? '';
export const colourHex = (key) => (SESSION_TYPE_COLOURS[key] || SESSION_TYPE_COLOURS.blue).hex;
export const typeColour = (x) => colourHex(typeOf(x)?.colour);

// Whether every type on an active weekly session needs approval (from the
// Session types list), so a new gymnast can't book anything until approved
export const allInUseNeedApproval = (types) => {
  const inUse = (types || []).filter(t => !t.archived && t.sessions > 0);
  return inUse.length > 0 && inUse.every(t => t.needsApproval);
};

// "Amy", "Amy and Ben", "Amy, Ben and Cal"
export const listOf = (names, last = 'and') => (names.length < 2 ? names.join('')
  : `${names.slice(0, -1).join(', ')} ${last} ${names[names.length - 1]}`);
